module.exports = __webpack_public_path__ + "static/media/wizualizacja-141.6a9bdc49.png";